import { buildSgPresetPrepareDocumentItem } from '../../presetDocCustSave';
import { classifyTransferDoc } from './transferDocVariableMap';
import {
  buildTransferRows,
  rowPersonLabel,
  toDirectorLetterVariables,
  toDirectorsResolutionVariables,
  toMembersResolutionVariables,
  toShareTransferFormVariables,
} from './useFormPayload';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
  docCode?: string;
}

export function buildTransferPresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  formData: Record<string, any>;
  directorsSignersJson: string;
  membersSignersJson: string;
  personName: string;
  entityCd?: string;
}) {
  const docs = (input.selectionDocuments || []).filter((d) => d.tmpId);
  if (docs.length === 0) return [];

  const rows = buildTransferRows({ formData: input.formData });
  const items: any[] = [];

  for (const d of docs) {
    const kind = classifyTransferDoc({
      docCode: d.docCode,
      templateName: d.templateName,
    });
    const templateName = d.templateName || '';
    const templateId = d.tmpId as number | string;

    if (kind === 'share_transfer_form_corporate' || kind === 'share_transfer_form_individual') {
      for (const row of rows) {
        const isCorpTransferor = row.transferorCategoryCd === 'B09001';
        if (kind === 'share_transfer_form_corporate' && !isCorpTransferor) continue;
        if (kind === 'share_transfer_form_individual' && isCorpTransferor) continue;
        items.push(
          buildSgPresetPrepareDocumentItem({
            templateId,
            templateName,
            personName: rowPersonLabel(row),
            commonFormData: toShareTransferFormVariables({ formData: input.formData, row }),
            entityCd: input.entityCd,
          }),
        );
      }
      continue;
    }

    if (kind === 'director_letter') {
      for (const row of rows) {
        items.push(
          buildSgPresetPrepareDocumentItem({
            templateId,
            templateName,
            personName: `${trim(input.formData.requestingDirectorName) || 'Director'} — ${rowPersonLabel(row)}`,
            commonFormData: toDirectorLetterVariables({ formData: input.formData, row }),
            entityCd: input.entityCd,
          }),
        );
      }
      continue;
    }

    if (kind === 'directors_resolution') {
      for (const row of rows) {
        items.push(
          buildSgPresetPrepareDocumentItem({
            templateId,
            templateName,
            personName: rowPersonLabel(row),
            commonFormData: toDirectorsResolutionVariables({
              formData: input.formData,
              row,
              directorsSignersJson: input.directorsSignersJson,
            }),
            entityCd: input.entityCd,
          }),
        );
      }
      continue;
    }

    if (kind === 'members_resolution') {
      for (const row of rows) {
        items.push(
          buildSgPresetPrepareDocumentItem({
            templateId,
            templateName,
            personName: rowPersonLabel(row),
            commonFormData: toMembersResolutionVariables({
              formData: input.formData,
              row,
              membersSignersJson: input.membersSignersJson,
            }),
            entityCd: input.entityCd,
          }),
        );
      }
    }
  }

  return items;
}

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}
